import FeatureItem from "./feature-item";

export default FeatureItem;
